import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Viverano Organics' "Viverano Branded Baby
// Garment Eco Hangers (25 pack)" (p_f2dfpfud7a), read from GET
// /api/product-reviews/product/p_f2dfpfud7a (the same data source that
// powers the product's own PDP review list) — verbatim comment, real
// reviewer, real rating, real publish date.
export const review_vo1: FaireReviewEntity = {
  token: "review_vo1",
  type: "review",
  brandName: "Viverano Organics",
  brandToken: "b_7fghelgl",
  productToken: "p_f2dfpfud7a",
  reviewType: "product",
  reviewerName: "Mike S.",
  reviewerLocation: "Tehachapi, CA",
  stars: 5,
  reviewText:
    "Beautiful designs. Outstanding quality. Excellent company to be partner with.",
  reviewDate: "May 14, 2025",
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
